import React, { FC } from 'react';
import { Form, Checkbox } from 'antd';

// Styles
import './language-filter.scss';

// Models
import { ILanguage } from '../../../../interfaces/core.interfaces';

type TLanguageFilterProps = {
  languages: ILanguage[];
}

export const LanguageFilter: FC<TLanguageFilterProps> = (
  { languages }: TLanguageFilterProps
) => {

  const options = languages.map(({ name, code }) => ({ value: code, label: name }));

  return (
    <div className="language-filter">
      <Form.Item name={ 'languages' }>
        <Checkbox.Group options={ options }/>
      </Form.Item>
    </div>
  );
}
